module.exports = __webpack_public_path__ + "fonts/TiemposTextWeb-Regular.fc9a9027.woff2";